import { FormRenderProps } from 'react-final-form';

import MaskedTextField from 'components/formInputs/MaskedTextField';
import { formattedNumberMask } from 'components/formInputs/MaskedTextField/masks';
import ToggleField from 'components/formInputs/ToggleField';
import FormWrapper from 'components/FormWrapper';
import { parseInteger } from 'forms/parsers';
import { InitialValues } from 'forms/types';

import SpousalQuoteInfo from './components/SpousalQuoteInfo';
import { HouseholdFormValues } from './types';

const HouseholdForm = ({
  handleSubmit,
  invalid,
  submitting,
}: FormRenderProps<HouseholdFormValues, InitialValues<HouseholdFormValues>>) => (
  <FormWrapper handleSubmit={handleSubmit} invalid={invalid} submitting={submitting}>
    <ToggleField name="spouseOrPartner" groupLabel="Do you have a spouse or partner?" />
    <ToggleField name="childrenOrPlanTo" groupLabel="Do you have children (or plan to)?" />
    <ToggleField
      name="buyingOrOwningHome"
      groupLabel="Are you buying or do you already own a home?"
    />
    <MaskedTextField
      name="annualIncome"
      label="What is your annual individual income?"
      maskOptions={formattedNumberMask}
      prefix="$"
      config={{ parse: parseInteger }}
      inputMode="numeric"
    />
    <SpousalQuoteInfo />
  </FormWrapper>
);

export default HouseholdForm;
